var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Layout',{staticClass:"CalloutCard",attrs:{"preKey":'pages',"columnComponents":_vm.PageCards.cards,"language":_vm.language}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }